import { createReducer, on } from '@ngrx/store';
import {
  Review,
  ReviewForm,
  ReviewsFilter
} from 'src/app/models/reviews.model';
import * as fromReviewsActions from '../actions/reviews.actions';
import { States } from 'src/app/enums/state.enum';

export interface ReviewsState {
  data: Review[];
  dataForms: ReviewForm[];
  loading: boolean;
  error: string;
  selectedReviewId: string;
  selectedFormReviewId: string;
  selectedTabIndex: number;
  filters: ReviewsFilter;
}

export const initialState: ReviewsState = {
  data: undefined as any,
  dataForms: undefined as any,
  loading: false,
  error: '',
  selectedReviewId: '',
  selectedFormReviewId: '',
  selectedTabIndex: 0,
  filters: undefined as any
};

export const reviewsReducer = createReducer(
  initialState,
  on(fromReviewsActions.LoadReviewsAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromReviewsActions.LoadReviewsSuccessAction, (state, { data }) => ({
    ...state,
    data,
    loading: false
  })),
  on(fromReviewsActions.LoadReviewsFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromReviewsActions.LoadReviewsFormsAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromReviewsActions.LoadReviewsFormsSuccessAction, (state, { data }) => ({
    ...state,
    dataForms: data,
    loading: false
  })),
  on(fromReviewsActions.LoadReviewsFormsFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromReviewsActions.SelectReviewAction, (state, { id }) => ({
    ...state,
    selectedReviewId: id
  })),
  on(fromReviewsActions.UnselectReviewAction, (state) => ({
    ...state,
    selectedReviewId: ''
  })),
  on(fromReviewsActions.AddFormAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromReviewsActions.AddFormSuccessAction, (state, { data }) => ({
    ...state,
    dataForms: [...state.dataForms, data],
    loading: false
  })),
  on(fromReviewsActions.AddFormFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromReviewsActions.EditFormAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromReviewsActions.EditFormSuccessAction, (state, { data }) => ({
    ...state,
    dataForms: state.dataForms.map((dataForm) =>
      dataForm.id === data.id ? data : dataForm
    ),
    data: state.data.map((review) => ({
      ...review,
      form: data.id === review.form!.id ? data : review.form
    })),
    loading: false
  })),
  on(fromReviewsActions.EditFormFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromReviewsActions.RemoveFormAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromReviewsActions.RemoveFormSuccessAction, (state, { id }) => ({
    ...state,
    dataForms: state.dataForms.filter((data) => data.id !== id),
    loading: false
  })),
  on(fromReviewsActions.RemoveFormFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromReviewsActions.SetTabIndexReviewAction, (state, { index }) => ({
    ...state,
    selectedTabIndex: index
  })),
  on(fromReviewsActions.CompleteReviewAction, (state) => ({
    ...state,
    loading: true
  })),
  on(fromReviewsActions.CompleteReviewSuccessAction, (state, { data }) => ({
    ...state,
    data: state.data.map((review) => ({
      ...review,
      reviewedDate:
        data.id === review.id ? data.reviewedDate : review.reviewedDate,
      state: data.id === review.id ? States.COMPLETED : review.state
    }))
  })),
  on(fromReviewsActions.CompleteReviewFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  })),
  on(fromReviewsActions.SaveReviewsFilters, (state, { filters }) => ({
    ...state,
    filters
  })),
  on(fromReviewsActions.CreateReviewSuccessAction, (state) => ({
    ...state,
    loading: false
  })),
  on(fromReviewsActions.CreateReviewFailAction, (state, { error }) => ({
    ...state,
    error: error.message
  }))
);
